import React from 'react'
import { NavbarComponent, FooterComponent } from '../../SharedComponents'
// import FacilitySection from '../LandingPage/FacilitySection'
// import ContactSection from '../LandingPage/ContactSection'
// import TreatmentProcessSection from '../LandingPage/TreatmentProcessSection'
// import ServiceSection from '../LandingPage/ServiceSection'
import './AboutPage.css'

export default function AboutPage() {
    return (
        <div>
            <NavbarComponent />
            {/* <FacilitySection />
            <ContactSection />
            <TreatmentProcessSection />
            <ServiceSection /> */}
            <FooterComponent />
        </div>
    )
}
